// עיצוב לסדרה (09 §1 `series`) — הלוגיקה ב-kit/series.js (משותפת ל-iframe של בלוק app); כאן הטיפוסים לדף המארח.
// כללים: group = גוון אחד לכל חברי הקבוצה; variant = רציף/מקווקו/מנוקד לפי סדר ההופעה; color (hex / '1'..'12' / 'muted')
// ו-dash מפורשים גוברים; סדרה בלי קבוצה תופסת את הצבע הבא; מעבר ל-12 צבעים — חזרה בקו מקווקו.
import type { ChartBlock, ChartDash } from '@aibify/core';
import { seriesStyles as kitStyles, withAlpha } from './kit/series.js';

export type SeriesStyle = { key: string; name: string; color: string; dash: ChartDash; /** אינדקס פלטה (0-based) כשהצבע מהפלטה; null לצבע hex/muted */ paletteIndex: number | null };

export function seriesStyles(block: Pick<ChartBlock, 'y' | 'series'>, palette: string[], muted?: string): SeriesStyle[] {
  return kitStyles(block, palette, muted);
}

export { withAlpha };
